(function () {

  function initBlogEditorial(section) {

    if (!section) {
      return;
    }

    if (
      section.dataset.blogEditorialInitialized === 'true'
    ) {
      return;
    }

    section.dataset.blogEditorialInitialized = 'true';


    /* =====================================================
       TAB ELEMENTS
       ===================================================== */

    const tabs = section.querySelectorAll(
      '.blog-editorial__tab'
    );

    const tabContents = section.querySelectorAll(
      '.blog-editorial__tab-content'
    );

    const rightPanels = section.querySelectorAll(
      '[data-right-panel]'
    );

    const searchButton = section.querySelector(
      '.blog-editorial__search'
    );

    const searchPanel = section.querySelector(
      '[data-search-panel]'
    );

    const searchInput = section.querySelector(
      '.blog-editorial__search-input'
    );

    const searchClose = section.querySelector(
      '[data-search-close]'
    );


    if (!tabs.length) {
      return;
    }


    /* =====================================================
       BLOG SEARCH
       ===================================================== */

    function closeSearch() {

      if (!searchPanel || !searchButton) {
        return;
      }

      searchPanel.hidden = true;

      searchButton.setAttribute(
        'aria-expanded',
        'false'
      );

    }


    function openSearch() {

      if (!searchPanel || !searchButton) {
        return;
      }

      searchPanel.hidden = false;

      searchButton.setAttribute(
        'aria-expanded',
        'true'
      );

      if (searchInput) {

        window.requestAnimationFrame(
          function () {

            searchInput.focus();

          }
        );

      }

    }


    if (searchButton && searchPanel) {

      searchButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          if (searchPanel.hidden) {

            openSearch();

            /* ===================================================
         JUMP TO TOP WHEN SEARCH IS OPENED
         =================================================== */
//          const sectionTop =
//   section.getBoundingClientRect().top;

// if (sectionTop < -5) {

//   section.scrollIntoView({
//     behavior: 'smooth',
//     block: 'start'
//   });

// }

          } else {

            closeSearch();

          }

        }
      );


      if (searchClose) {

        searchClose.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();

            closeSearch();

          }
        );

      }


      searchPanel.addEventListener(
        'click',
        function (event) {

          event.stopPropagation();

        }
      );


      document.addEventListener(
        'click',
        function (event) {

          if (
            !searchPanel.hidden &&
            !searchPanel.contains(event.target) &&
            !searchButton.contains(event.target)
          ) {

            closeSearch();

          }

        }
      );


      document.addEventListener(
        'keydown',
        function (event) {

          if (event.key === 'Escape') {

            closeSearch();

          }

        }
      );

    }


    /* =====================================================
       COMMUNITY TOP PICKS SLIDER
       ===================================================== */

    function initCommunitySlider(container) {

      if (!container) {
        return;
      }

      if (
        container.dataset.communityInitialized === 'true'
      ) {
        return;
      }

      container.dataset.communityInitialized = 'true';


      const slides = Array.from(
        container.querySelectorAll(
          '[data-community-slide]'
        )
      );

      const communityWrapper =
        container.closest(
          '.blog-editorial__community'
        );


      if (!slides.length || !communityWrapper) {
        return;
      }


      const prevButton =
        communityWrapper.querySelector(
          '[data-community-prev]'
        );

      const nextButton =
        communityWrapper.querySelector(
          '[data-community-next]'
        );

      const currentElement =
        communityWrapper.querySelector(
          '[data-community-current]'
        );

      const totalElement =
        communityWrapper.querySelector(
          '[data-community-total]'
        );


      let currentIndex = 0;


      /* ===================================================
         AUTOPLAY
         =================================================== */

      let autoplayTimer = null;

      const autoplayEnabled =
        container.dataset.autoplay === 'true';

      const autoplayInterval =
        (Number(container.dataset.autoplayInterval) || 5) * 1000;


      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerCurrentX = 0;

      let isPointerDown = false;
      let activePointerId = null;
      let isDragging = false;
      let suppressClick = false;


      /* ===================================================
         SHOW SLIDE
         =================================================== */

      function showSlide(index) {

        if (!slides.length) {
          return;
        }


        if (index < 0) {

          index = slides.length - 1;

        }

        if (index >= slides.length) {

          index = 0;

        }


        currentIndex = index;


        slides.forEach(
          function (slide, slideIndex) {

            slide.classList.toggle(
              'is-active',
              slideIndex === currentIndex
            );

          }
        );


        if (currentElement) {

          currentElement.textContent =
            currentIndex + 1;

        }


        if (totalElement) {

          totalElement.textContent =
            slides.length;

        }
        /* ADDED: UPDATE ARROW STATES */

        if (prevButton) {

          prevButton.classList.toggle(
            'is-disabled',
            currentIndex === 0
          );

        }

        if (nextButton) {

          nextButton.classList.toggle(
            'is-disabled',
            currentIndex === slides.length - 1
          );

        }

      }


      /* ===================================================
         AUTOPLAY + NEXT / PREVIOUS
         =================================================== */

      function stopAutoplay() {

        if (autoplayTimer) {

          window.clearInterval(
            autoplayTimer
          );

          autoplayTimer = null;

        }

      }


      function startAutoplay() {

        stopAutoplay();

        if (
          !autoplayEnabled ||
          slides.length <= 1
        ) {
          return;
        }

        autoplayTimer = window.setInterval(
          function () {

            showSlide(
              currentIndex + 1
            );

          },
          autoplayInterval
        );

      }


      function resetAutoplay() {

        if (autoplayEnabled) {

          startAutoplay();

        }

      }


      function goNext() {

        showSlide(
          currentIndex + 1
        );

        resetAutoplay();

      }


      function goPrevious() {

        showSlide(
          currentIndex - 1
        );

        resetAutoplay();

      }


      container.blogEditorialStartAutoplay =
        startAutoplay;

      container.blogEditorialStopAutoplay =
        stopAutoplay;


      if (prevButton) {

        prevButton.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();

            goPrevious();

          }
        );

      }


      if (nextButton) {

        nextButton.addEventListener(
          'click',
          function (event) {

            event.preventDefault();
            event.stopPropagation();

            goNext();

          }
        );

      }


      /* ===================================================
         MOUSE DRAG
         =================================================== */

      let mouseStartX = 0;
      let mouseCurrentX = 0;
      let isMouseDown = false;
      let isMouseDragging = false;
      let suppressMouseClick = false;


      container.addEventListener(
        'mousedown',
        function (event) {

          if (event.button !== 0) {
            return;
          }

          isMouseDown = true;
          isMouseDragging = false;
          suppressMouseClick = false;

          mouseStartX = event.clientX;
          mouseCurrentX = event.clientX;

          container.classList.add(
            'is-dragging'
          );

          event.preventDefault();

        }
      );


      container.addEventListener(
        'mousemove',
        function (event) {

          if (!isMouseDown) {
            return;
          }

          mouseCurrentX = event.clientX;

          const deltaX =
            mouseCurrentX -
            mouseStartX;

          if (Math.abs(deltaX) > 8) {

            isMouseDragging = true;
            suppressMouseClick = true;

          }

        }
      );


      function finishMouseDrag(event) {

        if (!isMouseDown) {
          return;
        }

        mouseCurrentX = event.clientX;

        const deltaX =
          mouseCurrentX -
          mouseStartX;

        isMouseDown = false;

        container.classList.remove(
          'is-dragging'
        );


        if (
          isMouseDragging &&
          Math.abs(deltaX) >= 40
        ) {

          if (deltaX < 0) {

            goNext();

          } else {

            goPrevious();

          }

        }


        if (isMouseDragging) {

          window.setTimeout(
            function () {

              suppressMouseClick = false;

            },
            0
          );

        } else {

          suppressMouseClick = false;

        }


        isMouseDragging = false;

      }


      container.addEventListener(
        'mouseup',
        finishMouseDrag
      );


      container.addEventListener(
        'mouseleave',
        function (event) {

          if (isMouseDown) {

            finishMouseDrag(event);

          }

        }
      );


      container.addEventListener(
        'click',
        function (event) {

          if (suppressMouseClick) {

            event.preventDefault();
            event.stopPropagation();

            suppressMouseClick = false;

          }

        },
        true
      );


      /* ===================================================
         POINTER DOWN
         =================================================== */

      container.addEventListener(
        'pointerdown',
        function (event) {

          if (event.pointerType === 'mouse') {
            return;
          }


          isPointerDown = true;

          activePointerId =
            event.pointerId;

          isDragging = false;
          suppressClick = false;

          pointerStartX =
            event.clientX;

          pointerStartY =
            event.clientY;

          pointerCurrentX =
            event.clientX;


          container.classList.add(
            'is-dragging'
          );


          try {

            container.setPointerCapture(
              event.pointerId
            );

          } catch (error) {}

        }
      );


      /* ===================================================
         POINTER MOVE
         =================================================== */

      container.addEventListener(
        'pointermove',
        function (event) {

          if (
            !isPointerDown ||
            (
              activePointerId !== null &&
              event.pointerId !== activePointerId
            )
          ) {
            return;
          }


          pointerCurrentX =
            event.clientX;


          const deltaX =
            pointerCurrentX -
            pointerStartX;


          const deltaY =
            event.clientY -
            pointerStartY;


          if (
            Math.abs(deltaX) > 8 &&
            Math.abs(deltaX) > Math.abs(deltaY)
          ) {

            isDragging = true;
            suppressClick = true;

          }

        }
      );


      /* ===================================================
         POINTER UP
         =================================================== */

      function finishPointer(event) {

        if (
          !isPointerDown ||
          (
            activePointerId !== null &&
            event.pointerId !== activePointerId
          )
        ) {
          return;
        }


        const deltaX =
          pointerCurrentX -
          pointerStartX;


        isPointerDown = false;

        activePointerId = null;


        container.classList.remove(
          'is-dragging'
        );


        if (
          isDragging &&
          Math.abs(deltaX) >= 40
        ) {

          if (deltaX < 0) {

            goNext();

          } else {

            goPrevious();

          }

        }


        if (isDragging) {

          window.setTimeout(
            function () {

              suppressClick = false;

            },
            0
          );

        } else {

          suppressClick = false;

        }


        try {

          if (
            event.pointerId !== undefined
          ) {

            container.releasePointerCapture(
              event.pointerId
            );

          }

        } catch (error) {}

      }


      container.addEventListener(
        'pointerup',
        finishPointer
      );

      container.addEventListener(
        'pointercancel',
        finishPointer
      );


      /* ===================================================
         PREVENT ARTICLE OPEN AFTER DRAG
         =================================================== */

      container.addEventListener(
        'click',
        function (event) {

          if (suppressClick) {

            event.preventDefault();
            event.stopPropagation();

            suppressClick = false;

          }

        },
        true
      );


      /* ===================================================
         INITIAL STATE
         =================================================== */

      showSlide(0);
      startAutoplay();

    }

        /* =====================================================
       RIGHT-SIDE ARTICLE CONTENT SLIDER

       This slider is intentionally separate from the
       Community's Top Picks slider.

       It only controls:
       - Right-side article image
       - Right-side article title
       - Right-side article text
       - Right-side article button

       It does NOT affect any other slider.
       ===================================================== */
function initRightArticleSlider(container) {

  if (!container) {
    return;
  }

  if (
    container.dataset.rightArticleInitialized === 'true'
  ) {
    return;
  }

  container.dataset.rightArticleInitialized = 'true';


  const slides = Array.from(
    container.querySelectorAll(
      '[data-right-article-slide]'
    )
  );


  if (!slides.length) {
    return;
  }


  let currentIndex = 0;


  /* ===================================================
     SHOW ARTICLE
     =================================================== */

  function showRightArticle(index) {

    if (!slides.length) {
      return;
    }


    if (index < 0) {
      index = slides.length - 1;
    }


    if (index >= slides.length) {
      index = 0;
    }


    currentIndex = index;


    slides.forEach(
      function (slide, slideIndex) {

        slide.classList.toggle(
          'is-active',
          slideIndex === currentIndex
        );

      }
    );


    /* UPDATE ALL COUNTERS */

    container
      .querySelectorAll(
        '[data-right-article-current]'
      )
      .forEach(
        function (currentElement) {

          currentElement.textContent =
            currentIndex + 1;

        }
      );


    container
      .querySelectorAll(
        '[data-right-article-total]'
      )
      .forEach(
        function (totalElement) {

          totalElement.textContent =
            slides.length;

        }
      );
      /* ADDED: UPDATE ARROW STATES */

    container
      .querySelectorAll(
        '[data-right-article-prev]'
      )
      .forEach(
        function (prevButton) {

          prevButton.classList.toggle(
            'is-disabled',
            currentIndex === 0
          );

        }
      );

    container
      .querySelectorAll(
        '[data-right-article-next]'
      )
      .forEach(
        function (nextButton) {

          nextButton.classList.toggle(
            'is-disabled',
            currentIndex === slides.length - 1
          );

        }
      );

  }


  /* ===================================================
     PREVIOUS / NEXT
     =================================================== */

  container.addEventListener(
    'click',
    function (event) {

      const prevButton =
        event.target.closest(
          '[data-right-article-prev]'
        );

      const nextButton =
        event.target.closest(
          '[data-right-article-next]'
        );


      if (prevButton) {

        event.preventDefault();
        event.stopPropagation();

        showRightArticle(
          currentIndex - 1
        );

        return;
      }


      if (nextButton) {

        event.preventDefault();
        event.stopPropagation();

        showRightArticle(
          currentIndex + 1
        );

      }

    }
  );


  /* ===================================================
     INITIAL STATE
     =================================================== */

  showRightArticle(0);

}


    /* =====================================================
       INITIALIZE ALL RIGHT-SIDE ARTICLE SLIDERS
       ===================================================== */

    function initAllRightArticleSliders() {

      section
        .querySelectorAll(
          '[data-right-article-slider]'
        )
        .forEach(
          function (slider) {

            initRightArticleSlider(slider);

          }
        );

    }


    initAllRightArticleSliders();


    /* =====================================================
       INITIALIZE ALL COMMUNITY SLIDERS
       ===================================================== */

    function initAllCommunitySliders() {

      section
        .querySelectorAll(
          '[data-community-slider]'
        )
        .forEach(
          function (slider) {

            initCommunitySlider(slider);

          }
        );

    }


    initAllCommunitySliders();


    /* =====================================================
       TAB SWITCHING
       ===================================================== */

    function activateTab(target) { 

      if (!target) {
        return;
      }


      // tabs.forEach(
      //   function (tab) {

      //     const isActive =
      //       tab.dataset.blogTab === target;

      //     tab.classList.toggle(
      //       'is-active',
      //       isActive
      //     );

      //     tab.setAttribute(
      //       'aria-selected',
      //       isActive
      //         ? 'true'
      //         : 'false'
      //     );

      //   }
      // );
      tabs.forEach(
       function (tab) {

        tab.addEventListener(
       'click',
       function (event) {

        event.preventDefault();

        const target =
          tab.dataset.blogTab;


        /* ===================================================
           ACTIVATE THE CLICKED TAB
           =================================================== */

        activateTab(target);


        /* ===================================================
           JUMP TO TOP ONLY IF SECTION IS ABOVE VIEWPORT
           =================================================== */

        const sectionTop =
          section.getBoundingClientRect().top;

        if (sectionTop < -5) {

          section.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }


        /* ===================================================
           MAKE SURE CLICKED TAB REMAINS ACTIVE
           =================================================== */

        tabs.forEach(
          function (currentTab) {

            const isActive =
              currentTab.dataset.blogTab === target;

            currentTab.classList.toggle(
              'is-active',
              isActive
            );

            currentTab.setAttribute(
              'aria-selected',
              isActive
                ? 'true'
                : 'false'
            );

          }
        );

      }
     );

      }
      );


      tabContents.forEach(
        function (content) {

          const contentTarget =
            content.dataset.blogContent;

          const isActive =
            contentTarget === target;

          content.classList.toggle(
            'is-active',
            isActive
          );


          /* STOP AUTOPLAY FOR INACTIVE TAB */

          if (!isActive) {

            const inactiveSlider =
              content.querySelector(
                '[data-community-slider]'
              );

            if (
              inactiveSlider &&
              inactiveSlider.blogEditorialStopAutoplay
            ) {

              inactiveSlider.blogEditorialStopAutoplay();

            }

          }


          if (isActive) {

            const activeSlider =
              content.querySelector(
                '[data-community-slider]'
              );


            if (
              activeSlider &&
              activeSlider.dataset.communityInitialized === 'true'
            ) {

              const slides =
                activeSlider.querySelectorAll(
                  '[data-community-slide]'
                );


              slides.forEach(
                function (slide, index) {

                  slide.classList.toggle(
                    'is-active',
                    index === 0
                  );

                }
              );


              const wrapper =
                activeSlider.closest(
                  '.blog-editorial__community'
                );


              if (wrapper) {

                const current =
                  wrapper.querySelector(
                    '[data-community-current]'
                  );

                const total =
                  wrapper.querySelector(
                    '[data-community-total]'
                  );


                if (current) {

                  current.textContent = '1';

                }

                if (total) {

                  total.textContent =
                    slides.length;

                }

              }


              if (
                activeSlider.blogEditorialStartAutoplay
              ) {

                activeSlider.blogEditorialStartAutoplay();

              }

            }

          }

        }
      );


      /* ===================================================
         COMMON RIGHT-SIDE PANEL
         =================================================== */

      rightPanels.forEach(
        function (panel) {

          const panelTarget =
            panel.dataset.rightPanel;

          panel.classList.toggle(
            'is-active',
            panelTarget === target
          );

        }
      );

    }


    tabs.forEach(
      function (tab) {

        tab.addEventListener(
          'click',
          function () {

            activateTab(
              tab.dataset.blogTab
            );

          }
        );

      }
    );


    /* =====================================================
       ALL TAB — SORT + INITIAL LIMIT
       ===================================================== */

    const allLatestGrid =
      section.querySelector(
        '[data-all-latest-grid]'
      );


    if (allLatestGrid) {

      const articles =
        Array.from(
          allLatestGrid.querySelectorAll(
            '.blog-editorial__article'
          )
        );


      /* SORT NEWEST FIRST */

      articles.sort(
        function (a, b) {

          const dateA =
            Number(
              a.dataset.published || 0
            );

          const dateB =
            Number(
              b.dataset.published || 0
            );

          return dateB - dateA;

        }
      );


      articles.forEach(
        function (article) {

          allLatestGrid.appendChild(
            article
          );

        }
      );


      /* APPLY GLOBAL INITIAL LIMIT */

      const initialLimit =
        parseInt(
          section.dataset.latestLimit,
          10
        ) || 6;


      articles.forEach(
        function (article, index) {

          article.classList.toggle(
            'is-load-more-hidden',
            index >= initialLimit
          );

        }
      );

    }


    /* =====================================================
       SHOW MORE — LATEST ARTICLES
       ===================================================== */

    function initShowMoreButtons() {

      section
        .querySelectorAll(
          '[data-show-more]'
        )
        .forEach(
          function (button) {

            if (
              button.dataset.showMoreInitialized === 'true'
            ) {
              return;
            }

            button.dataset.showMoreInitialized =
              'true';


            const latest =
              button.closest(
                '.blog-editorial__latest'
              );


            if (!latest) {
              return;
            }


            const step =
              Number(
                button.dataset.showMoreStep || 6
              );


            // function updateButton() {

            //   const hiddenCards =
            //     latest.querySelectorAll(
            //       // '.blog-editorial__article.is-load-more-hidden'
            //       '.blog-editorial__article.is-load-more-hidden:not(.is-filtered-out)'
            //     );


            //   button.hidden =
            //     hiddenCards.length === 0;

            // }
            function updateButton() {

            const hiddenCards =
              latest.querySelectorAll(
                '.blog-editorial__article.is-load-more-hidden:not(.is-filtered-out)'
              );

            button.hidden =
              hiddenCards.length === 0;

            // only while a tag filter is active: really hide the button
            if (latest.dataset.filtered === 'true') {
              button.classList.toggle(
                'is-filter-hidden',
                hiddenCards.length === 0
              );
            }

          }


            button.addEventListener(
              'click',
              function () {

                const hiddenCards =
                  Array.from(
                    latest.querySelectorAll(
                      // '.blog-editorial__article.is-load-more-hidden'
                      '.blog-editorial__article.is-load-more-hidden:not(.is-filtered-out)'
                    )
                  );


                hiddenCards
                  .slice(0, step)
                  .forEach(
                    function (card) {

                      card.classList.remove(
                        'is-load-more-hidden'
                      );

                    }
                  );


                updateButton();

              }
            );


            updateButton();

          }
        );

    }

    /* =====================================================
   TAG FILTER
   ===================================================== */

function initTagFilters() {

  section.querySelectorAll('[data-tag-filter]').forEach(function (filter) {

    if (filter.dataset.tagFilterInitialized === 'true') {
      return;
    }
    filter.dataset.tagFilterInitialized = 'true';

    const content = filter.closest('.blog-editorial__tab-content');
    if (!content) { return; }

    const latest = content.querySelector('.blog-editorial__latest');
    const grid = latest.querySelector('.blog-editorial__latest-grid');
    const showMore = latest.querySelector('[data-show-more]');
    const buttons = filter.querySelectorAll('[data-filter-tag]');
    const initialLimit = parseInt(section.dataset.latestLimit, 10) || 6;

    const emptyMessage = document.createElement('p');
    emptyMessage.className = 'blog-editorial__filter-empty';
    emptyMessage.textContent = 'No articles found for this tag.';
    emptyMessage.hidden = true;
    grid.appendChild(emptyMessage);

    let activeTag = null;

    function applyFilter(tag) {

      const cards = Array.from(
        grid.querySelectorAll('.blog-editorial__article')
      );

      let shown = 0;

      cards.forEach(function (card) {

        const cardTags = (card.dataset.tags || '').split('|');
        const matches = !tag || cardTags.indexOf(tag) !== -1;

        card.classList.toggle('is-filtered-out', !matches);

        if (matches) {
          card.classList.toggle('is-load-more-hidden', shown >= initialLimit);
          shown++;
        }

      });

      emptyMessage.hidden = shown !== 0;

      // if (showMore) {
      //   showMore.hidden = !grid.querySelector(
      //     '.blog-editorial__article.is-load-more-hidden:not(.is-filtered-out)'
      //   );
      // }
      latest.dataset.filtered = tag ? 'true' : '';

      if (showMore) {
        const hasMore = !!grid.querySelector(
          '.blog-editorial__article.is-load-more-hidden:not(.is-filtered-out)'
        );

        showMore.hidden = !hasMore;

        if (tag) {
          // filter active: hide the button when 6 or fewer posts match
          showMore.classList.toggle('is-filter-hidden', !hasMore);
        } else {
          // filter cleared: back to the original behaviour
          showMore.classList.remove('is-filter-hidden');
        }
      }

    }

    buttons.forEach(function (button) {

      button.addEventListener('click', function () {

        const tag = button.dataset.filterTag;

        activeTag = (activeTag === tag) ? null : tag; // click again = clear

        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.filterTag === activeTag);
        });

        applyFilter(activeTag);

        latest.scrollIntoView({ behavior: 'smooth', block: 'start' });

      });

    });

  });

}

initTagFilters();



    initShowMoreButtons();


    /* =====================================================
       INITIAL RIGHT-SIDE STATE
       ===================================================== */

    const initialActiveTab =
      section.querySelector(
        '.blog-editorial__tab.is-active'
      );


    if (initialActiveTab) {

      activateTab(
        initialActiveTab.dataset.blogTab
      );

    } else {

      const firstTab =
        section.querySelector(
          '.blog-editorial__tab'
        );


      if (firstTab) {

        activateTab(
          firstTab.dataset.blogTab
        );

      }

    }

  }


  /* =======================================================
     INITIALIZE ALL SECTIONS
     ======================================================= */

  function initAllBlogEditorialSections() {

    document
      .querySelectorAll(
        '.blog-editorial'
      )
      .forEach(
        function (section) {

          initBlogEditorial(
            section
          );

        }
      );

  }


  /* =======================================================
     INITIAL PAGE LOAD
     ======================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllBlogEditorialSections
    );

  } else {

    initAllBlogEditorialSections();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR — SECTION LOAD
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '.blog-editorial'
        );


      if (section) {

        section.dataset.blogEditorialInitialized =
          'false';


        initBlogEditorial(
          section
        );

      }

    }
  );


  /* =======================================================
     SHOPIFY THEME EDITOR — SECTION SELECT
     ======================================================= */

  document.addEventListener(
    'shopify:section:select',
    function (event) {

      const section =
        event.target.querySelector(
          '.blog-editorial'
        );


      if (section) {

        if (
          section.dataset.blogEditorialInitialized !== 'true'
        ) {

          initBlogEditorial(
            section
          );

        }

      }

    }
  );

})();

